import { render, staticRenderFns } from "./DispatcherType.vue?vue&type=template&id=655529d4&"
import script from "./DispatcherType.vue?vue&type=script&lang=js&"
export * from "./DispatcherType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports